function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowButtonBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.92,
    xmlns: "http://www.w3.org/2000/svg",
    height: 41.535,
    id: "screenshot-56b63548-60f0-80ed-8003-6ee4506e19cd",
    viewBox: "-0 -0 36.92 41.535",
    style: {
      WebkitPrintColorAdjust: "exact"
    },
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-56b63548-60f0-80ed-8003-6ee4506e19cd",
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-56b63548-60f0-80ed-8003-6ee4506e19d2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-56b63548-60f0-80ed-8003-6ee4506e19d2"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 17.045310216780535,
    y: 3.6603489938797793,
    transform: "matrix(-0.000000, -1.000000, 1.000000, 0.000000, 0.259961, 40.580659)",
    width: 6.749999999999545,
    height: 33,
    style: {
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-56b63548-60f0-80ed-8003-6ee4506e19d3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-56b63548-60f0-80ed-8003-6ee4506e19d3"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 7.767145164779322,
    y: -0.9740336014406239,
    transform: "matrix(-0.664364, -0.747409, 0.664364, -0.747409, 10.049964, 29.737584)",
    width: 6.3860198872212095,
    height: 26.608416196760118,
    style: {
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-56b63548-60f0-80ed-8003-6ee4506e19d4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-56b63548-60f0-80ed-8003-6ee4506e19d4"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 8.892590300907614,
    y: 15.743762555862304,
    transform: "matrix(0.677244, -0.735758, 0.651337, 0.758789, -15.039135, 15.900522)",
    width: 6.372941768239798,
    height: 26.66279699091274,
    style: {
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowButtonBlack);
export default __webpack_public_path__ + "static/media/arrow-button-black.c06d76378b5930696fc3f8d1a7324d19.svg";
export { ForwardRef as ReactComponent };